import { Search } from "lucide-react";

import { DebouncedInput } from "@/components/common/DebouncedInput";
import { Card, CardContent } from "@/components/ui/card";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import type { UsersPageFilters } from "@/features/users/hooks/useUsersPage";

interface UsersFiltersProps {
  filters: UsersPageFilters;
  onFiltersChange: (filters: Partial<UsersPageFilters>) => void;
  searchTerm: string;
  onSearchChange: (term: string) => void;
  isLoading?: boolean;
}

export function UsersFilters({
  filters,
  onFiltersChange,
  searchTerm,
  onSearchChange,
  isLoading = false,
}: UsersFiltersProps) {
  const handleRoleChange = (value: string) => {
    onFiltersChange({ role: value });
  };

  return (
    <Card>
      <CardContent className="p-6">
        <div className="flex flex-col sm:flex-row gap-4">
          <div className="flex-1">
            <div className="relative">
              <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 h-4 w-4 text-muted-foreground" />
              <DebouncedInput
                type="text"
                placeholder="Buscar usuarios..."
                value={searchTerm}
                onChange={onSearchChange}
                className="pl-10"
                debounce={800}
              />
            </div>
          </div>
          <div className="flex gap-2">
            <Select
              value={filters.sortBy || "active_imaging"}
              onValueChange={(val) =>
                onFiltersChange({ sortBy: val as "active_imaging" | "created_at" })
              }
              disabled={isLoading}
            >
              <SelectTrigger className="w-[200px]">
                <SelectValue placeholder="Ordenar por" />
              </SelectTrigger>
              <SelectContent>
                <SelectItem value="active_imaging">Con Imagenología Activa</SelectItem>
                <SelectItem value="created_at">Todos</SelectItem>
              </SelectContent>
            </Select>

            <Select
              value={filters.role}
              onValueChange={handleRoleChange}
              disabled={isLoading}
            >
              <SelectTrigger className="w-[180px]">
                <SelectValue placeholder="Todos los roles" />
              </SelectTrigger>
              <SelectContent>
                <SelectItem value="Todos los roles">Todos los roles</SelectItem>
                <SelectItem value="Admin">Admin</SelectItem>
                <SelectItem value="Médico">Médico</SelectItem>
                <SelectItem value="Paciente">Paciente</SelectItem>
                <SelectItem value="Institución">Institución</SelectItem>
              </SelectContent>
            </Select>
          </div>
        </div>
      </CardContent>
    </Card>
  );
}
